import React from 'react';
import { arrayUtils, HighlightedCard } from '@sato/components';
import { observer } from 'mobx-react-lite';

import { Link } from '@components/common/Link';
import { ROUTES } from '@routes/routes.constants';
import { apartmentStore } from '@stores/apartmentStore';
import { localizationStore } from '@stores/localization';

export const BroadbandCard = observer(
  ({ className }: { className?: string }) => {
    const t = localizationStore.getTranslation;

    const internet = apartmentStore.selectedApartment?.apartment.internet;

    const isInternetIncluded = !!internet?.provider;

    return (
      <HighlightedCard
        layout="horizontal"
        icon="broadband"
        iconPosition="left"
        title={
          isInternetIncluded
            ? arrayUtils.joinArrayString([internet.provider, internet.speed])
            : t('internet_not_included_title')
        }
        {...(isInternetIncluded
          ? {
              pretitle: t('realEstateInternetLabel'),
              ...(internet?.agreement === 'SATO_FRAMEWORK' && {
                buttonProps: {
                  children: t('read_more'),
                  icon: 'arrowRight',
                  iconPosition: 'right',
                  to: ROUTES.BROADBAND,
                  wrapperComponent: Link,
                },
              }),
            }
          : { body: t('internet_not_included_body') })}
        color="primary"
        className={className}
      />
    );
  }
);
